(function (factory) {
    typeof define === 'function' && define.amd ? define(factory) :
    factory();
})((function () { 'use strict';

    /**
     * Decode obfuscated email address via user interaction "click"
     * 
     * @see [email] shortcode
     * @see https://spencermortensen.com/articles/email-obfuscation/
     */
    (function(){
        function decode(str) {
            return str.replace(/<b>.*?<\/b>/gi, "").replace(/<i>.*?<\/i>/gi, "").replace(/<em>|<\/em>/gi, ""); 
        }
        document.body.addEventListener('click', function(e){
            if (!e.target.closest('a.email.mailto')) return;
            e.target.href = 'mailto:' + decode(e.target.innerHTML);
        });
    })();

}));
